<template>
  <Card>
    <Item
      title="新增客户"
      content="本月新增的广告主"
      @change="handleChange"
      @expand="handleExpand"
    />
    <div
      ref="newAccount"
      style="height: 270px; margin-top: 28px"
    />
  </Card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import echart from 'echarts';

import Card from '../../Card/Index';
import Item from '../Item/Index';

import mixin from '../mixins/';
import chart from '../mixins/chart';

const { mapState, mapActions } = createNamespacedHelpers(
  'directSaleReport/dataView',
);

export default {
  components: {
    Card,
    Item,
  },

  mixins: [mixin, chart],

  data() {
    return {
      type: 'new_account',
    };
  },

  computed: {
    ...mapState({
      dataSource: (state) => state.newAccount.slice(-3),
    }),
  },

  watch: {
    async sale(newVal) {
      this.setDataSource();
    },
  },

  async created() {
    this.setDataSource();
  },

  mounted() {
    this.chart = echart.init(this.$refs.newAccount);
  },

  methods: {
    ...mapActions(['updateNewAccount']),

    async handleChange(sum) {
      this.sum = sum;
      this.setDataSource();
    },

    async setDataSource() {
      const res = await this.queryDirectActiveAndNew();
      if (res) {
        this.updateNewAccount(res);
        const option = this.getOption();
        this.chart.setOption(option, true);
      }
    },
  },
};
</script>